




import {
  Component,
  Vue,
  Prop,
} from 'vue-property-decorator';

@Component
export default class OverlayComponent extends Vue {
  @Prop()
  isShown!: boolean;

  resolutionBan = false;

  handleResize() {
    this.checkResolution();
  }

  mounted() {
    this.checkResolution();
  }

  checkResolution() {
    if (window.innerWidth > 1280) {
      this.resolutionBan = true;
    } else {
      this.resolutionBan = false;
    }
  }
}
